export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This action will permanently delete the asset"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to continue?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You will no longer see this asset in your list."])}
}